require('./bootstrap');
require('./lib/metismenu.min');
import Notify from "./utilities/notification";

/**
 * Load the currently mounted modules
 * @type {jQuery|undefined}
 */
window.$('.module').each(function (module) {
    let currentModuleName = window.$(this).attr('data-module');
    let path = "./modules/";

    if (currentModuleName.includes('admin.')) {
        path = "./admin/modules/";
        currentModuleName = currentModuleName.replace('admin.', '');
    }

    import(/* webpackChunkName: "[request]" */path + currentModuleName + '.js').then(function (module) {

        module.default();

        if (window.params.environment === "local" || window.params.environment === "testing") {
            console.log(currentModuleName + ' loaded');
        }
    });
});

$(function () {
    $("#app").removeClass('isLoading').children('.overlay-loader').fadeOut();

    // Mobile menu z-index change
    $(document).on('change', '.header_mobile input[type=checkbox]', function () {
        const zIndex = $(this).is(':checked') ? 1 : -1;
        $(this).closest('nav').find('.nav-links').css('z-index', zIndex);
    });

    // hide schmodal on click outside
    $(document).on('click', function (e) {
        e.stopPropagation()
        if ($(e.target).hasClass('schmodal-dialog')) {
            $(e.target).closest('.schmodal').schmodal('hide')
        }
    });

    $("select.select2").each((_, select) => {
        const modal = $(select).closest('.schmodal');
        const parent = modal.length ? $(modal) : $(document.body)
        $(select).select2({
            dropdownParent: parent
        })
    });

    const messages = window.messages || [];
    messages.forEach((message) => {
        Notify.error(message)
    });

})



